import axios from 'axios';
import * as authService from './authService';
import { API_BASE_URL } from '../config';

const api = axios.create({
    baseURL: API_BASE_URL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request Interceptor: No longer needed for tokens as we use cookies
api.interceptors.request.use(
    (config) => {
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response Interceptor: Handle 401 & Refresh using cookies
api.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const originalRequest = error.config;

        // Check if error is 401 (Unauthorized) or 403 (Forbidden) and not a retry
        if (error.response && (error.response.status === 401 || error.response.status === 403) && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                console.log(`Access token expired (Status ${error.response.status}). Attempting to refresh via cookie...`);

                // Call refresh-token endpoint (cookies are sent automatically)
                const result = await authService.refreshAccessToken();

                if (result && result.success) {
                    console.log('Token refreshed successfully. Retrying request...');
                    // Retry original request (cookies will be automatically included)
                    return api(originalRequest);
                }
            } catch (refreshError) {
                console.error('Token refresh failed during interceptor:', refreshError);
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export default api;
